<template>
  <div class="bg-white">
    <div class="relative z-index1 h-full w-full">
      <div class="">
        <CoverShareWork />
        <ShareWorkContent />
        <ShareWorkForm class="pb-5" />
        <!-- <ShareWorkForm class="blur relative" />
        <div
          class="absolute bottom-0 left-0 blur1 w-full h-1030px flex justify-center items-center"
        >
          <p class="fsize60 sm-fsize25">Coming soon....</p>
        </div> -->
      </div>
    </div>
    <div class="bge3ceff-opa rounded-t-5555">
      <DownloadApp />
      <Footer />
    </div>
  </div>
</template>

<script>
import CoverShareWork from "./components/CoverShareWork.vue";
import ShareWorkContent from "./components/ShareWorkContent.vue";
import ShareWorkForm from "./components/ShareWorkForm.vue";
import Footer from "../../Footer.vue";
import DownloadApp from "@/views/home/components/DownloadApp.vue";
export default {
  components: {
    CoverShareWork,
    ShareWorkContent,
    ShareWorkForm,
    Footer,
    DownloadApp,
  },
};
</script>

<style>
.blur {
  filter: blur(5px);
  -webkit-filter: blur(5px);
}
.blur1 {
  background-color: rgb(0, 0, 0);
  background-color: rgb(0, 0, 0, 0.68);
  color: white !important;

  font-weight: bold;
  z-index: 2;
  text-align: center;
}
.h-1030px {
  height: 1030px;
}
.fsize60 {
  font-size: 60px;
}
@media (max-width: 640px) {
  .h-1030px {
    height: 985px;
  }
}
</style>
